var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIn1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "url(#pattern0_680_475)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_680_475",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_680_475",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_680_475",
    width: 32,
    height: 32,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAA9gAAAPYBa0iqmwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAKISURBVFiFvdbNi81RGAfwzx3TYCYL2XgZNbIiCzGkWHiLYhZ2xIpC2fgHLCy8NGSjRtnZGikljBlJYiFClt5l8prCwkvhWpx785szv/O7v2uYp5665/e8fL/3nOec56kolgq60YPV6MR0fMNrPMZFXMDLBrmalrW4jWoJ/Yl+zP0XwB21ZGWAY/2G3WMB78S9RPJfwjbfwgN8KCDSh5ZmwTsS4M+wBzMj/woW4Ri+5MQdbZbAaaP/8WG0lYjtxI0cElvKgq/LAd9Rnjs1omejPK8wpVFgxehqP5Tw3SUUaD9W5Ng7cD/Kta8RgaVRwHNMTPiezPhtTfgsN7qGKinwFmyMvvXieyPWBXITVzPrLqFYkwRWZdZVnBsDeF3iHEuKnJ/6s10vItt23Mno+4zv08i2IBMXH+vxFHir8LbX5U1kn4HFidg5Na1LR+b368i3PUWgxcjzThVfszIpBydJIMu208iKPSE0mLr2Z2x7I9v9jG12hJPslK14hHm19TQsFJ5k+FjTunzO/H4n1EGerInWD1MEWnAp+rYt5VxSWrE5s/6FK0UELgj9vC57MGsMBHYYORfcxNtGQaeMvDbX5TehdkytaZ59vnBM2Vw9ZVh3CcNENvCMguuTAM++KVVhZphcNsHuKLiKu1jWIK4VO/EpJ76KAaOvZVL6EkmGhNroFgaTuViJA8ItajSqlSZRwf4SCf9GBzVxHFuEYaJZkKI5sYrLzZCYIgwTTxok/YFr2CBs80AzJJKDQkbqw2e30PHaMAHDwgs3JHTJukwS2vH6gpyD2ISvJfD/SsruROnb8b9IHPmfBAjHdb6AQDx/jDuJ4fEgQPo4Do4XAcK01Su8L8M18LbfTwU00fJ1CDkAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn1);
export default __webpack_public_path__ + "static/media/zoom-in1.1acf5b55545d71bde852aee6b580a8b5.svg";
export { ForwardRef as ReactComponent };